// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.savedsearch.HpApiSavedSearchV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  HpApiResponseDto,
  HpSavedSearchCreateRequestDto,
  HpSavedSearchDto,
  HpSavedSearchListResponseDto,
  HpSavedSearchUpdateRequestDto,
} from '../..';

interface DeleteParams {
  searchId: string;
}
interface ListParams {
  page?: number;
  pageSize?: number;
}

export const HpApiSavedSearchV3Handler_create_Path = '/api/web/v3/user/savedSearch/create';

/**
 * Create a saved search for the authenticated user
 */
export const HpApiSavedSearchV3Handler_create = (postData: HpSavedSearchCreateRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpSavedSearchCreateRequestDto, HpApiResponseDto<HpSavedSearchDto>>(
    {
      endpoint: HpApiSavedSearchV3Handler_create_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiSavedSearchV3Handler_delete_Path = '/api/web/v3/user/savedSearch/delete';

/**
 * Delete a saved search for the authenticated user
 */
export const HpApiSavedSearchV3Handler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpApiRequest<DeleteParams, never, HpApiResponseDto<boolean>>(
    {
      getParams: getParams,
      endpoint: HpApiSavedSearchV3Handler_delete_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiSavedSearchV3Handler_list_Path = '/api/web/v3/user/savedSearch/list';

/**
 * List the authenticated user's saved searches
 */
export const HpApiSavedSearchV3Handler_list = (getParams: ListParams, client = getClient()) => {
  return httpApiRequest<ListParams, never, HpApiResponseDto<HpSavedSearchListResponseDto>>(
    {
      getParams: getParams,
      endpoint: HpApiSavedSearchV3Handler_list_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiSavedSearchV3Handler_update_Path = '/api/web/v3/user/savedSearch/update';

/**
 * Update an existing saved search for the authenticated user
 */
export const HpApiSavedSearchV3Handler_update = (postData: HpSavedSearchUpdateRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpSavedSearchUpdateRequestDto, HpApiResponseDto<HpSavedSearchDto>>(
    {
      endpoint: HpApiSavedSearchV3Handler_update_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
